module.exports = __webpack_public_path__ + "components/dropdown-search-combo/static/icon-search-grey-165c29e49c6d54244d6e07d1ce93c8b4.svg";